module.exports = __webpack_public_path__ + "img/ow.9188d6b1.png";